import { Dispatch, Middleware } from 'redux';

import { eventsService } from '../services/events.service';
import { Actions, TypeKeys } from './actions';
import { ApplicationState } from './reducers';

export const appMiddleware: Middleware<{}, ApplicationState, Dispatch<Actions>> = (_store) => next => (action: Actions) => {
  const result = next(action);
  if (action.type === TypeKeys.APP_LOAD_SUCCESS) {
    eventsService.emit('appLoaded', action.app.id);
  }
  return result;
};
